export const iconFontAwesomeMapsHeartPulse = (
	<i className="fa-solid fa-heart-pulse"></i>
);
